import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { targetIcon } from '../../icons';

export const Autobroker = () => (
  <ErrorWrapper icon={targetIcon}>Вы не&nbsp;можете делать ставку, пока включена автостратегия</ErrorWrapper>
);
